import { Injectable } from '@angular/core';

@Injectable({
    providedIn: 'root'
})
export class AppointmentsService {

    constructor() { }

    getEventType(eventType: string) {
        if (eventType === 'Pickup') {
            return 'pickup';
        } else if (eventType === 'Delivery') {
            return 'delivery';
        } else if (eventType === 'Survey') {
            return 'onsite_survey';
        } else if (eventType === 'Sales') {
            return 'sales';
        } else if (eventType === 'Build') {
            return 'onsite_build';
        } else if (eventType === 'Customer Drop off') {
            return 'cust_dropoff';
        } else if (eventType === 'Other') {
            return 'Other';
        }
    }
}
